import goodTick from './tick.svg'
import badTick from './badTick.svg'

export const ticks = {goodTick, badTick}

